/* Phase 6B (Phase 6A registration retained): tile-origin navigation handoff; Shopify still owns every page. */
(function () {
  'use strict';
  const storefront = window.BSStorefront;
  if (!storefront || !storefront.lifecycle || storefront.homeShopShell) return;

  storefront.homeShopShell = {
    unregister: storefront.lifecycle.register('bs-home-shop-shell', '.bs-home-hub', function (root) {
      const selector = 'a[data-bs-home-handoff][href]';
      if (!root.querySelector(selector)) return;
      const removers = [];
      let disposed = false, pending = null, returning = null, navigating = false;
      let motion;

      function listen(target, type, handler, options) {
        const guarded = event => { if (!disposed) handler(event); };
        target.addEventListener(type, guarded, options);
        removers.push(() => target.removeEventListener(type, guarded, options));
      }

      function clear() {
        const current = pending;
        pending = null; // Invalidate promise callbacks before canceling animations.
        if (!current) return;
        window.clearTimeout(current.timer);
        current.animations.forEach(animation => animation.cancel());
        if (current.panel) current.panel.remove();
      }

      function cancel() { returning = null; clear(); }

      function finish(current) {
        if (disposed || pending !== current) return;
        if (!root.isConnected || !current.link.isConnected || !root.contains(current.link)) { cancel(); return; }
        clear();
        navigating = true;
        try { window.location.assign(current.href); }
        catch (error) { returning = null; navigating = false; } // Leave the original link usable for retry.
      }

      function onClick(event) {
        const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        const link = anchor && anchor.matches(selector) && anchor.closest('.bs-home-hub') === root ? anchor : null;
        // A different activation invalidates every continuation of the previous tile.
        if (anchor && pending && anchor !== pending.link) cancel();
        if (!link) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) { cancel(); return; }
        if (link.hasAttribute('download') || (link.target && link.target.toLowerCase() !== '_self')) { cancel(); return; }
        if (pending || navigating) { event.preventDefault(); return; }

        // Everything before preventDefault may fail back to ordinary anchor activation.
        let current;
        try {
          const destination = new URL(link.href, window.location.href);
          if (!/^https?:$/.test(destination.protocol) || destination.origin !== window.location.origin || destination.href === window.location.href) return;
          if (!motion || motion.matches || typeof root.animate !== 'function' || document.hidden || !root.isConnected) return;
          const style = window.getComputedStyle(link);
          if (style.visibility === 'hidden' || style.visibility === 'collapse' || style.display === 'none') return;
          const labelNode = link.querySelector('.bs-home-hub__tile-label');
          const label = (link.getAttribute('aria-label') || (labelNode && labelNode.textContent) || link.textContent || '').trim();
          if (!label) return;
          const rect = link.getBoundingClientRect();
          const width = window.innerWidth, height = window.innerHeight;
          if (!(rect.width > 0 && rect.height > 0 && width > 0 && height > 0) || rect.bottom <= 0 || rect.right <= 0 || rect.top >= height || rect.left >= width) return;

          current = { link, href: link.href, panel: null, animations: [], timer: 0 };
          pending = current;
          const panel = document.createElement('div');
          current.panel = panel;
          panel.className = 'bs-home-shop-handoff';
          panel.setAttribute('aria-hidden', 'true');
          panel.textContent = label;
          document.body.appendChild(panel);
          // A failed style/unsupported animation must never intercept a working link.
          if (window.getComputedStyle(panel).position !== 'fixed' || typeof panel.animate !== 'function') { cancel(); return; }
          const expansion = panel.animate([
            { transform: 'translate(' + rect.left + 'px,' + rect.top + 'px) scale(' + rect.width / width + ',' + rect.height / height + ')', opacity: 0.85 },
            { transform: 'translate(0,0) scale(1,1)', opacity: 1 }
          ], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' });
          current.animations.push(expansion);
          expansion.finished.then(() => finish(current), () => finish(current));
          const recede = root.animate([{ opacity: 1 }, { opacity: 0.3 }], { duration: 320, fill: 'forwards' });
          current.animations.push(recede);
          recede.finished.catch(() => finish(current));
          current.timer = window.setTimeout(() => finish(current), 450);
          returning = link;
          link.focus({ preventScroll: true });
          event.preventDefault(); // Existing delegated navigation audio honors this.
        } catch (error) {
          if (pending === current) cancel();
        }
      }

      function dispose() {
        disposed = true;
        cancel();
        removers.forEach(remove => remove());
      }

      try {
        motion = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
        listen(root, 'click', onClick);
        listen(document, 'click', event => {
          const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
          if (anchor && anchor !== (pending ? pending.link : returning)) cancel();
        });
        listen(document, 'keydown', event => { if (event.key === 'Escape' || event.key === 'Tab') cancel(); });
        listen(window, 'resize', cancel);
        listen(document, 'visibilitychange', () => { if (document.hidden && pending) cancel(); });
        listen(window, 'pagehide', clear);
        listen(window, 'pageshow', event => {
          clear();
          if (event.persisted && returning && root.isConnected && returning.isConnected && root.contains(returning)) returning.focus({ preventScroll: true });
          returning = null;
          navigating = false;
        });
        const motionChanged = () => { if (motion.matches && pending) finish(pending); };
        if (motion && typeof motion.addEventListener === 'function') listen(motion, 'change', motionChanged);
        else if (motion && typeof motion.addListener === 'function') {
          motion.addListener(motionChanged);
          removers.push(() => motion.removeListener(motionChanged));
        }
        return dispose;
      } catch (error) { dispose(); throw error; }
    })
  };
})();
